/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import {
  DefaultLinkWidget, PointModel, LinkWidget, DefaultLinkSegmentWidget,
} from '@projectstorm/react-diagrams';
import React from 'react';
import CrossConnectLinkModel from '../CrossConnectLink/CrossConnectLinkModel';
import BandwidthLinkModel from './BandwidthLinkModel';
import BoldLinkPath from '../LinkHelpers';

const CustomBoldBackground = (x1: number, x2: number, y1: number, y2: number, color: string | undefined) => {
  return (<line key={1} x1={x1} y1={y1} x2={x2} y2={y2} stroke={color || 'grey'} opacity={0.5} colorInterpolation="auto" strokeWidth={20} />);
};

class BandwidthLinkWidget extends DefaultLinkWidget {
  generateLink(path: string, extraProps: any, id: string | number): JSX.Element {
    const ref = React.createRef<SVGPathElement>();
    this.refPaths.push(ref);
    return (
      <DefaultLinkSegmentWidget
        key={`link-${id}`}
        path={path}
        selected={false}
        diagramEngine={this.props.diagramEngine}
        factory={this.props.diagramEngine.getFactoryForLink(this.props.link)}
        link={this.props.link}
        forwardRef={ref}
        onSelection={() => {}}
        extras={extraProps}
      />
    );
  }

  render() {
    // ensure id is present for all points on the path
    const points = this.props.link.getPoints();
    const paths = [];
    this.refPaths = [];
    // const str = offsetPath(LinkWidget.generateLinePath(points[0], points[1]));
    const str = LinkWidget.generateLinePath(points[0], points[1]);
    const myElement = this.generateLink(
      str,
      {
        onMouseEnter: () => {
          BoldLinkPath(this.props.link, 8);
          this.props.link.setHovered(true);
          this.props.diagramEngine.repaintCanvas();
        },
        onMouseLeave: () => {
          this.props.link.setHovered(false);
          BoldLinkPath(this.props.link, 2);
          this.props.diagramEngine.repaintCanvas();
        },
      },
      '0',
    );
    paths.push(myElement);

    if (this.props.link.getOptions().extras.sourceCollapsed
    && this.props.link.getOptions().extras.targetCollapsed
    && this.props.link.getOptions().extras.first) {
      const x1 = this.props.link.getFirstPoint().getPosition().x;
      const y1 = this.props.link.getFirstPoint().getPosition().y;
      const x2 = this.props.link.getLastPoint().getPosition().x;
      const y2 = this.props.link.getLastPoint().getPosition().y;
      const { color } = this.props.link.getOptions();
      paths.push(
        CustomBoldBackground(x1, x2, y1, y2, color),
      );
    }

    return <g className="link-bandwidth" data-default-link-test={this.props.link.getOptions().testName}>{paths}</g>;
  }
}

export default BandwidthLinkWidget;
